import { Button } from '@heroui/react';
import { MinusSquareDashed } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';

type EmptyLogsViewProps = {
  hasFilters: boolean;
  onClear: () => void;
};

export function EmptyLogsView({ hasFilters, onClear }: EmptyLogsViewProps) {
  return (
    <div
      className='flex flex-col gap-4 py-12'
      data-testid='monitor-pipeline-logs-empty-view'
    >
      <div className='flex items-center justify-center px-6 py-2'>
        <div className='rounded-lg bg-surface-container p-4'>
          <MinusSquareDashed className='h-12 w-12 text-on-surface' />
        </div>
      </div>

      <div className='flex flex-col items-center justify-center gap-6 text-center'>
        <div>
          <h2
            className='mb-1 text-headline-md font-semibold text-on-surface'
            data-testid='monitor-pipeline-logs-empty-title'
          >
            {i18n.t('scenes.pipeline_logs.empty.title')}
          </h2>
          <p
            className='text-body-regular-md text-on-surface'
            data-testid='monitor-pipeline-logs-empty-subtitle'
          >
            {i18n.t('scenes.pipeline_logs.empty.subtitle')}
          </p>
        </div>
        {hasFilters && (
          <Button
            variant='bordered'
            size='md'
            color='primary'
            className='h-8 border-1 text-sm font-semibold leading-tight tracking-tight'
            onPress={onClear}
            data-testid='monitor-pipeline-logs-empty-clear-filters-button'
          >
            {i18n.t('scenes.pipeline_logs.empty.clear_filters')}
          </Button>
        )}
      </div>
    </div>
  );
}
